import { render, staticRenderFns } from "./QuotationTaskHandle.vue?vue&type=template&id=3af1f17a"
import script from "./QuotationTaskHandle.vue?vue&type=script&lang=js"
export * from "./QuotationTaskHandle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports